import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaUserTie } from "react-icons/fa";

type KeyType = 'AD' | 'CC' | 'TR' | 'CO' | 'SC' | 'PO';

const keys: Record<KeyType, string> = {
  AD: 'Admin Flow',
  CC: 'Content Creation',
  TR: 'Trainer Flow',
  CO : 'Coordinator Flow',
  SC : 'Sub Coordinator Flow',
  PO : 'Placement Officer Flow',
};

function LoginCards() {
  const location = useLocation();
  const navigate = useNavigate();
  const [datas, setDatas] = useState<KeyType[]>([]);

  if (location?.state?.data) {
    if (Array.isArray(location.state.data)) {
      location.state.data = location.state.data.filter((item: string) => item !== "CC");
    }
    sessionStorage.setItem("Dashboard", String(location.state.data));
  }
  

  useEffect(() => {
    const storedData = sessionStorage.getItem('Dashboard');
    if (storedData) {
      const dataArray = storedData.split(',') as KeyType[];
      setDatas(dataArray);
    }
  }, []);


  const navigateFunction = (key: KeyType) => {
    if (key === "AD") {
      navigate('/admin/courses');
      sessionStorage.setItem("Admin", "True");
      sessionStorage.setItem("activeAdminMainMenu", "Master Data");
    } else if (key === "TR") {
      navigate('/trainer/reports');
      sessionStorage.setItem("Trainer", "True");
      sessionStorage.setItem("activeTrainerMainMenu", "Reports");
    }
    else if (key === "CO") {
      sessionStorage.setItem("Coordinator", "True");
      navigate('/coordinator/filter-page')
    }
    else if (key === "SC") {
      sessionStorage.setItem("Coordinator", "True");
      sessionStorage.setItem("SC", "True");
      navigate('/coordinator/filter-page')
    }
    else if (key === "PO") {
      sessionStorage.setItem("PO", "True");
      navigate('/placement-officer/company')
    }
  };

  const isKeyType = (key: string): key is KeyType => {
    return key in keys;
  };

  return (
    <div className="container mt-4">
      <div className="row g-4 d-flex justify-content-center align-items-center">
        {datas.map((key) =>
          isKeyType(key) ? (
            <div key={key} className="col-md-4" role="button" onClick={() => navigateFunction(key)}>
              <div className="card shadow-sm p-5 border-primary">
                <div className="card-body text-center">
                  <h5 className="card-title text-primary">{keys[key]}</h5>
                  <p className="card-text">Code: <strong>{key}</strong></p>
                  <FaUserTie className="card-icon" />
                </div>
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}

export default LoginCards;
